// extracted by mini-css-extract-plugin
module.exports = {"inlineFormContainer":"jgp-1fx6h","elements":"jgp-Crt4K"};